import React, {Fragment, useContext, useEffect} from "react";
import {GlobalContext} from "../admin-frame/AdminFrame";
import {useRenderableData} from "../common/hooks/useRenderableData";
import {MessageDisplayerUtility} from "../common/MessageDisplayerUtility";
import {ApiUtility} from "../common/ApiUtility";
import {ConditionalRenderer} from "../common/ConditionalRenderer";
import {OverlayLoadingIndicator} from "../common/OverlayLoadingIndicator";
import _ from "lodash";
import {Constants} from "../common/Constants";
import {UpdateFpServices} from "./UpdateFpServices";
import {UpdateFpServiceType} from "./UpdateFpServiceType";

export const FpServicesManagementPage = function (props) {
    const context = useContext(GlobalContext);
    const urlBase = '/fp-qbo-integration/for-service-type';
    const renderableData = useRenderableData({
        fpServiceTypeId: null,
        prevParams: null,
        loading: true
    });

    useEffect(function () {
        renderableData.updateAndRender({loading: true})
        ApiUtility.getFpServiceTypesList()
            .then(function (fpServiceTypesData) {
                let fpServiceTypes = fpServiceTypesData.fpServiceTypeList
                renderableData.updateAndRender({
                    fpServiceTypes: fpServiceTypes,
                    loading: false,
                });

                if (!renderableData.fpServiceTypeId) {
                    let fpInternalServiceType = _.find(fpServiceTypes, function (fpServiceType) {
                        return fpServiceType.name === Constants.fpServiceTypeNames.internalService
                    })
                    let fpInternalServiceTypeId = fpInternalServiceType && fpInternalServiceType.id
                    goToFpServiceType(fpInternalServiceTypeId)
                }
            })
            .catch(function (error) {
                renderableData.updateAndRender({loading: false});
                console.log(`Error loading FP service types: `, error);
                MessageDisplayerUtility.error(`Error fetching FP service types.`);
            });
    }, []);

    // Update state if URL changes.
    if ((props.match && props.match.params) !== renderableData.prevParams) {
        let fpServiceTypeId = null;

        let routeParams = props.match && props.match.params;
        if (
            routeParams &&
            routeParams['fpServiceTypeId']
        ) {
            fpServiceTypeId = routeParams['fpServiceTypeId'];
        }

        renderableData.updateAndRender({
            fpServiceTypeId: fpServiceTypeId,
            prevParams: props.match && props.match.params,
        })
    }

    function goToFpServiceType(fpServiceTypeId) {
        context.navigator.navigateTo(`${urlBase}/${fpServiceTypeId}`);
    }

    if (renderableData.fpServiceTypes) {
        return (
            <div className="common-form-page fp-services-management-page">
                <div className="common-form-page-header">
                    <div className="common-form-page-header-content">
                        <div className="common-form-page-header-content-left">
                            <div className="common-form-page-header-text">
                                FP Service ↔ QBO Account Integration
                            </div>
                        </div>
                    </div>
                </div>
                <div className="common-form-page-content">
                    <ConditionalRenderer
                        if={renderableData.loading}
                        renderer={() => <OverlayLoadingIndicator/>}
                    />
                    <ConditionalRenderer
                        if={renderableData.fpServiceTypes && renderableData.fpServiceTypes.length > 0}
                        renderer={() => {
                            let fpServiceTypeTabs = [];
                            for (let i = 0; i < renderableData.fpServiceTypes.length; i++) {
                                let fpServiceType = renderableData.fpServiceTypes[i];
                                fpServiceTypeTabs.push(
                                    <FpServiceTypeTab
                                        key={i}
                                        name={fpServiceType.name + 's'}
                                        onClick={() => goToFpServiceType(fpServiceType.id)}
                                        selected={'' + renderableData.fpServiceTypeId === '' + fpServiceType.id}
                                    />
                                )
                            }

                            return (
                                <Fragment>
                                    <div className="fp-service-type-tabs">
                                        <div className="fp-service-type-tabs-content">
                                            {fpServiceTypeTabs}
                                        </div>
                                    </div>
                                    <ConditionalRenderer if={renderableData.fpServiceTypeId} renderer={() => (
                                        <Fragment>
                                            <UpdateFpServiceType
                                                fpServiceTypeId={renderableData.fpServiceTypeId}
                                            />
                                            <UpdateFpServices
                                                fpServiceTypeId={renderableData.fpServiceTypeId}
                                                fpServiceTypes={renderableData.fpServiceTypes}
                                            />
                                        </Fragment>
                                    )}/>
                                </Fragment>
                            )
                        }}
                    />
                </div>
            </div>
        );
    } else {
        return (
            <OverlayLoadingIndicator/>
        );
    }
}

const FpServiceTypeTab = (props) => {
    return (
        <div
            className={`fp-service-type-tab ${props.selected && 'selected'}`}
            onClick={props.onClick}
        >
            <div className="fp-service-type-tab-text">
                {props.name}
            </div>
        </div>
    )
}
